import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { AppSettingService } from 'src/app/services/app-setting.service';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LicenseLiabilityService {


  constructor(private http: HttpClient) { }

  getLicenses(): Observable<any> {
    return this.http
      .get(AppSettingService.getLicensesUri ).pipe(catchError(this.error));

  }
  getLiabilities(): Observable<any> {
    return this.http
      .get(AppSettingService.getLiabilitiesUri ).pipe(catchError(this.error));

  }
  
  test(): Observable<any> {
    return this.http
      .get(AppSettingService.getAvailabilitiesUri).pipe(catchError(this.error));

  }

  getLicense(licenseId:any): Observable<any> {
    return this.http
      .get(AppSettingService.getLicenseUri +"?Id="+licenseId).pipe(catchError(this.error));

  }

  
  addLicense(model:any): Observable<any> {
    // console.log(model)
    return this.http
      .post(AppSettingService.addLicenseUri ,model).pipe(catchError(this.error));

  }

  getLiability(licenseId:any): Observable<any> {
    return this.http
      .get(AppSettingService.getLiabilityUri +"?Id="+licenseId).pipe(catchError(this.error));

  }

  
  getLiabilityTypes(){

    return this.http
    .get(AppSettingService.getLiabiltiyTypesUri ).pipe(catchError(this.error));
  }
  getLicenseTypes(){

    return this.http
    .get(AppSettingService.getLicenseTypesUri ).pipe(catchError(this.error));
  }
  addLiability(model:any): Observable<any> {
    // console.log(model)
    return this.http
      .post(AppSettingService.addLiabilityUri ,model).pipe(catchError(this.error));

  }
  error(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(error);
    return throwError({ error: error.error, status: error.status });
  }
}